import SingleCarousel from './modules/single-carousel';
import { getUrlVars } from './modules/util';

SingleCarousel.init();

let downloadForm = document.querySelector('.download-ebook-form');
let hiddenDownloadAnchor = document.querySelector('a.hidden-download');
if (downloadForm && hiddenDownloadAnchor) {
  downloadForm.addEventListener('submit', () => {
    hiddenDownloadAnchor.click();
  });
}

window.addEventListener('load', function() {
  // on white-paper page this would redirect to respective(ID) ebookpage
  // on individual ebookpage this will open modal for download by default
  let pdfId = getUrlVars()['id'];
  let button = document.querySelector(`.btn[data-id='${pdfId}']`);
  if (pdfId && button) {
    button.click();
  }
});
